export map from './map'
export redirect from './redirect'



// WEBPACK FOOTER //
// ./src/system/plugins/index.js